import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { elevation } from '../Styles/Utils/elevation.js';

/* istanbul ignore file */ const Sides = {
    BOTTOM: "BOTTOM",
    TOP: "TOP"
};
const SnapPositions = {
    LEFT: "LEFT",
    RIGHT: "RIGHT"
};
const PositionPairs = {
    topLeft: `${Sides.TOP}-${SnapPositions.LEFT}`,
    topRight: `${Sides.TOP}-${SnapPositions.RIGHT}`,
    bottomLeft: `${Sides.BOTTOM}-${SnapPositions.LEFT}`,
    bottomRight: `${Sides.BOTTOM}-${SnapPositions.RIGHT}`
};
const TriangleSVG = ({ className , fill , style  })=>/*#__PURE__*/ React.createElement("svg", {
        style: style,
        className: className,
        width: "24",
        height: "12",
        viewBox: "0 0 24 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 0L0 12H24L12 0Z",
        fill: fill
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12 0L0 12H24L12 0Z",
        fill: fill,
        fillOpacity: "0.75"
    }));
const Container = styled.div.withConfig({
    displayName: "styled__Container",
    componentId: "sc-feb201f0-0"
})`
    position: relative;
    box-sizing: border-box;
    display: inline-block;
`;
const ChildrenContainer = styled(Container).withConfig({
    displayName: "styled__ChildrenContainer",
    componentId: "sc-feb201f0-1"
})`
    display: flex;

    &:hover {
        cursor: pointer;
    }
`;
const CommonTriangle = styled(TriangleSVG).withConfig({
    displayName: "styled__CommonTriangle",
    componentId: "sc-feb201f0-2"
})`
    position: absolute;
    z-index: ${(props)=>props.zIndex || 12};
    ${(props)=>props.side === Sides.TOP && css`
            transform: rotate(180deg);
        `}
`;
const Triangles = {
    [Sides.BOTTOM]: styled(CommonTriangle).withConfig({
        displayName: "styled",
        componentId: "sc-feb201f0-3"
    })`
        bottom: 100%;
    `,
    [Sides.TOP]: styled(CommonTriangle).withConfig({
        displayName: "styled",
        componentId: "sc-feb201f0-4"
    })`
        top: 100%;
    `
};
const appear = keyframes`
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;
const hover = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(4px);
  }
  100% {
    transform: translateY(0px);
  }
`;
const AnimationContainer = styled.div.withConfig({
    displayName: "styled__AnimationContainer",
    componentId: "sc-feb201f0-5"
})`
    animation: ${hover} 3s infinite;
`;
const TextContainer = styled(Container).withConfig({
    displayName: "styled__TextContainer",
    componentId: "sc-feb201f0-6"
})`
    position: absolute;
    animation: ${appear} 0.5s ease-out;

    ${(props)=>{
    switch(`${props.side}-${props.snapPosition}`){
        case PositionPairs.topLeft:
            {
                return `
            bottom: ${props.verticalOffset}px;
            left: ${props.pointerOffset || 0}px;
          `;
            }
        case PositionPairs.topRight:
            {
                return `
            bottom: ${props.verticalOffset}px;
            right: ${props.pointerOffset || 0}px;
          `;
            }
        case PositionPairs.bottomLeft:
            {
                return `
            top: ${props.verticalOffset}px;
            left: ${props.pointerOffset || 0}px;
          `;
            }
        case PositionPairs.bottomRight:
            {
                return `
            top: ${props.verticalOffset}px;
            right: ${props.pointerOffset || 0}px;
          `;
            }
        default:
            return "";
    }
}}
`;
const Text = styled.p.withConfig({
    displayName: "styled__Text",
    componentId: "sc-feb201f0-7"
})`
    margin: 0;
    color: ${({ theme  })=>theme.colors.Background};
    ${(props)=>css(props.theme.typography.Paragraph)};
`;
const Wrap = styled(Container).withConfig({
    displayName: "styled__Wrap",
    componentId: "sc-feb201f0-8"
})`
    position: relative;
    text-transform: none;
    user-select: none;
    pointer-events: none;
    min-width: ${(props)=>props.width}px;
    max-width: 384px;
    text-align: center;
    white-space: ${(props)=>props.textWrap ? "normal" : "nowrap"};
    padding: 8px;
    border-radius: 8px;
    background: ${(props)=>props.theme.colors.secondary};
    color: ${({ theme  })=>theme.colors.Background};
    z-index: ${(props)=>props.zIndex || 12};

    ${elevation(3, false)}
`;

export { AnimationContainer, ChildrenContainer, CommonTriangle, Container, Sides, SnapPositions, Text, TextContainer, TriangleSVG, Triangles, Wrap, appear, hover };
